
































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment'
import AlertArea from "../../components/AlertArea.vue"
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue"
import PdfRenderArea from "../../components/PdfRenderArea.vue"
import { Sheet } from "../../modules/teacher/MondaiPdfUpload"

export interface Data {
  tabNo: number
  sheet_group_key: string
  sheet: Sheet
  base64Pdf: string
  errors: string[]
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "pdf-render-area": PdfRenderArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    const pdfRenderAreaRef = ref<InstanceType<typeof PdfRenderArea>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 4,
      sheet_group_key: "",
      sheet: new Sheet(),
      base64Pdf: "",
      errors: new Array<string>()
    });

    /******************************
     * 解答PDF画面へ移動
     ******************************/

    const toKaitouPdfUpload = () => {
      context.root.$router.push(`/teacher_site/kaitou_pdf_upload/${state.sheet_group_key}`).catch(err => {});
    };

    /******************************
     * ファイルアップロード
     ******************************/

    const upload = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/mondai_pdf_upload/upload/${state.sheet_group_key}`, fd).then(response => {
        alert("アップロードが完了しました。");
        location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      await http.get(`/api/teacher/mondai_pdf_upload?sheet_group_key=${state.sheet_group_key}`).then(response => {
        
        const sheet = new Sheet();
        sheet.grade = response.data.sheet.grade;
        sheet.name = response.data.sheet.name;
        sheet.curriculum_id = response.data.sheet.curriculum_id;
        sheet.score_positions_completed = response.data.sheet.score_positions_completed;
        sheet.question_image_completed = response.data.sheet.question_image_completed;
        state.sheet = sheet;
        
        context.root.$nextTick(() => {
          if(state.sheet.question_image_completed){
            state.base64Pdf = response.data.base64_pdf;
          }
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      upload,
      toKaitouPdfUpload,
    };
  }
});
